import React, {Component} from 'react';
import TextField from '@material-ui/core/TextField';

/**
 * A free-text MUI TextField that buffers its value in local state so the caret
 * never jumps to the end while typing.
 *
 * The lineage inspector edits nodes that live in Redux; every keystroke changes
 * `map` identity and re-renders the whole editor shell + the React Flow island,
 * which re-feeds a (briefly lagging) `value` back into the input and resets the
 * caret. Rendering from local state — updated in the SAME tick as the keystroke —
 * decouples the input from that async churn. The buffer re-syncs from `value`
 * only when it changes externally (switching nodes, or an auto-derived label).
 *
 * Drop-in for a controlled free-text <TextField>: same `value` prop and same
 * event-based `onChange(e)` contract, so call sites only swap the component name.
 * Not for `select` fields (dropdowns don't have a caret to preserve).
 */
class BufferedTextField extends Component {
  state = {value: this.props.value != null ? this.props.value : ''};

  componentDidUpdate(prevProps) {
    const next = this.props.value != null ? this.props.value : '';
    // Reseed only on an external change — not our own keystroke echo (which
    // arrives as value===buffer, so the second guard is false).
    if (this.props.value !== prevProps.value && next !== this.state.value) {
      this.setState({value: next});
    }
  }

  handleChange = (e) => {
    this.setState({value: e.target.value});
    if (this.props.onChange) this.props.onChange(e);
  };

  render() {
    const rest = {...this.props};
    delete rest.value;
    delete rest.onChange;
    return <TextField {...rest} value={this.state.value} onChange={this.handleChange} />;
  }
}

export default BufferedTextField;
